/** Used as an action type when starting the create floor plan saga */
export const CREATE_FLOOR_PLAN = 'CREATE_FLOOR_PLAN'

/** Used as an action type when adding a new floor plan to the state */
export const ADD_FLOOR_PLAN = 'ADD_FLOOR_PLAN'

/** Used as an action type when removing floor plan from the state */
export const REMOVE_FLOOR_PLAN = 'REMOVE_FLOOR_PLAN'

/** Used as an action type when removing floor plan from the state */
export const DESTROY_FLOOR_PLAN = 'DESTROY_FLOOR_PLAN'

/** Used as an action type when updating a floor plan */
export const UPDATE_FLOOR_PLAN = 'UPDATE_FLOOR_PLAN'

/** Used as an action type when starting to scale a floor plan */
export const SCALE_FLOOR_PLAN = 'SCALE_FLOOR_PLAN'

/** Used as an action type when cancelling scaling a floor plan */
export const CANCEL_SCALE_FLOOR_PLAN = 'CANCEL_SCALE_FLOOR_PLAN'



// WEBPACK FOOTER //
// ./src/actions/floorPlanActionTypes.js